<template>
  <label class="themed-checkbox">
    <input
      :id="id"
      type="checkbox"
      :checked="isChecked"
      :disabled="disabled"
      class="themed-checkbox__input"
      :aria-invalid="ariaInvalid"
      :aria-describedby="ariaDescribedby"
      :aria-required="ariaRequired"
      v-bind="$attrs"
      @change="handleChange"
    />
    <span v-if="label" class="themed-checkbox__label">{{ label }}</span>
    <slot v-else></slot>
  </label>
</template>

<script>
export default {
  name: 'ThemedCheckbox',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaRequired: {
      type: String,
      default: null
    }
  },
  computed: {
    isChecked() {
      // Support both 'value' (v-model) and 'checked' props
      // Check if 'checked' prop was explicitly passed (not undefined)
      if (this.$options.propsData && 'checked' in this.$options.propsData) {
        return this.checked;
      }
      return this.value;
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.target.checked);
      this.$emit('change', event.target.checked);
    }
  }
}
</script>


